import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

const Map = ({ onLoad, ...props }) => {
  useEffect(() => {
    if (onLoad) onLoad();
  }, [onLoad]);

  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      preserveAspectRatio="xMidYMid slice"
      viewBox="0 0 1920 1066"
    >
      <polygon
        data-building="F"
        points="360 446 360 456.8 352 458 360 539.85 462 589 461 523 471 520 471 515.24 488 513 488 503.89 492 497 507 490 586 474 588 460 588 454.44 625.49 446 625.49 443.08 599 438 599 430 583 428 577 424 547 425 534 421 465 433 456 431 444 434 432 432 425 426 365 434 365 439 362 440 362 445 360 446"
      />

      <polygon
        data-building="E"
        points="462 589 461 523 471 520 471 515.24 488 513 488 503.89 492 497 507 490 586 474 588 460 588 454.44 625.49 446 654 441 654 438.65 657.78 438.65 657.78 428.73 669.61 428.73 674 431 674 433.25 677 433 677 436.04 683 440 683 442.8 686 443 699 441 699 448.11 703 448 703 444.98 710 438 720 438 720 445.61 722 445.61 722 444.2 723 444.2 723 440.37 751 440.37 808 452 808 455.33 824 457 824 459.89 809 463 809 465 812 466 812 468 846 476 846 478.34 829 484 829 487 857 492 857 493.85 840 497 840 598 831 597 775 616 775 618 724 634 724 649 584 712 463 625 462 589"
      />

      <polygon
        data-building="A"
        points="724 634 733 842 999 961 1103 897 1103 835.51 1109 831 1109 819.92 1103 818 1103 811 1110 806 1111 714 1106 713 1106 706 1115 702 1115 699.12 1107 696 1107 681 1071 672 1067 674 1016 659 1016 627 968 614 962.55 614 950 610 933 616 907 609 890 612 840 598 831 597 775 616 775 618 724 634"
      />

      <polygon
        data-building="B"
        points="965.12 614 968 614 1016 627 1016 659 1067 674 1071 672 1107 681 1107 696 1115 699.12 1115 702 1106 706 1106 713 1111 714 1110.14 793.29 1246 840 1335 777 1341 651 1334 650 1334 644 1359 630 1359 618.64 1344 615 1359 608.58 1359 597.59 1354.04 597.59 1354 593 1361 590 1361 586.29 1280 570 1265 568 1238 579 1222 576 1222 560 1175 550 1171 551 1162 548 1156.7 548 1147 552 1121 546 1105 551 1054 540 1010 556 1003 556 967 568 963 569 963 570.67 967 571 967 580 962 582 962 592.15 966 593 966 603 962 603 962 612.93 965 612.93 965.12 614"
      />

      <polygon
        data-building="C"
        points="1361 586.29 1361 590 1354 593 1354.04 597.59 1359 597.59 1359 608.58 1344 615 1359 618.64 1359 630 1334 644 1334 650 1341 651 1338.3 707.76 1428 733 1500.02 659.64 1504 589 1497 589 1497 584 1506 578 1506 568.34 1497 568 1497 562 1508 557 1508 554.5 1500 553 1500 545 1368 518 1368 501 1287 486 1272 492 1251 490 1251 495.01 1219 489 1203 495 1197 494 1185 498 1135 489 1135 474.86 1116 472 1116 467.63 1083 466 1067 470 1059 470 1054 474 1041 476 1027 480 1018 480 1018 483.13 1007 486 1007 483.92 997 484 997 488.97 994 489 994 497.15 972 504 972 516.1 953 520 951.93 610.61 961.54 613.68 962 612.93 962 603 966 603 966 593 962 592.15 962 582 967 580 967 571 963 570.67 963 569 1003 556 1010 556 1054 540 1105 551 1121 546 1147 552 1156.7 548 1162 548 1171 551 1175 550 1222 560 1222 576 1238 579 1265 568 1280 570 1361 586.29"
      />
    </svg>
  );
};

Map.propTypes = {
  onLoad: PropTypes.func.isRequired,
};

export default Map;
